<template>
  <div class="full-screen landing-page app-bg-gradient">
      <!-- <swiper :options="swiperOption" class="bg-img">
        <swiper-slide v-for="(slide, index) in swiperSlides" :key="index" :class="(index === 2 ? 'heightFull' : '')"><img :src="slide" /></swiper-slide>
      </swiper> -->
      <!-- <div class="back-drop">
      </div> -->
      <!-- <img src="/static/images/epod-backdrop-img.jpg" class="background-image"/> -->
      <div class="stars"></div>
      <div class="logo-left-sec">
        <div class="bgimg">
          <img src="/static/images/backdrop-mosque.png" />
        </div>
        <img src="/static/images/logo.png" class="logo" />
        <ul>
          <li>lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml</li>
          <li>lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml</li>
          <li>lorem ipsumlorem ipsumlorem ipsumlorem ipsumlorem ipsuml</li>
        </ul>
        <!-- <div class="quote">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla pulvinar ipsum semper risus ultricies, quis molestie orci vehicula. Sed dignissim turpis fringilla turpis scelerisque, at efficitur nisi accumsan. Proin maximus sem sed porttitor molestie.</div> -->
      </div>
      <div class="landing-row-sec">
        <div class="mosque-login-details">
          <div class="login">
            <loginForm
                v-bind:token="token"
                v-bind:userAction='userAction'
                v-bind:errorMsg='errorMsg'
                :buttonName='btnName'
                @checkUser='checkUser'>
            </loginForm>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import loginForm from './login-form.vue'

export default {
  name: 'Login',
  data () {
    return {
      userAction: 'login',
      errorMsg: false,
      btnName: 'Login',
      tid: null
      // swiperOption: {
      //   autoplay: 3500,
      //   setWrapperSize: true,
      //   observeParents: true,
      //   loop: true
      // },
      // swiperSlides: ['/static/images/slides/slide1n.jpg', '/static/images/slides/slide4n.jpg', '/static/images/slides/slide3n.jpg']
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'loginStatus'
    ]),
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    ...mapActions([
      'login',
      'changeLoadingStatus',
      'loadTranslations'
    ]),
    checkUser (a) {
      let loginId = a.loginId
      let password = a.password
      let vm = this
      if (loginId && password) {
        this.login({loginId, password}).then((as) => {
          if (this.token) {
            console.log(this.token)
            this.$router.push({path: `/${this.tid}/home`})
            // this.$router.push({name: 'Home'}, (a) => console.log(arguments))
          }
        }).catch(error => {
          vm.errorMsg = error
          setTimeout(() => {
            vm.errorMsg = false
          }, 3000)
        })
      } else {
        vm.userNotFount = 'Enter valid details'
        setTimeout(() => {
          vm.errorMsg = false
        }, 3000)
      }
    }
  },
  components: {
    loginForm
  },
  mounted: function () {
    this.tid = this.$route.params.terminalId
    this.loadTranslations()
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (this.token) {
        // console.log(this.user)
        this.$router.push({path: `/${this.tid}/home`})
        // this.$router.push({name: 'Home'}, (a) => console.log(arguments))
      } else {
        window.document.title = 'EPODTECH'
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page {
  display: flex;
  /* background-image: url('/static/images/epod-backdrop-img.jpg'); */
  justify-content: space-between;
  position: relative;
}
.background-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}
  .landing-row-sec {
    display: flex;
    width: 50%;
    justify-content: center;
  }
  .mosque-login-details {
    padding-top: 79px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }
  .mosque-login-details .login {
    height: 67vh;
    z-index: 2;
    width:50% !important;
    display: flex;
    justify-content: center;
  }
  .logo-left-sec {
    width: 50%;
  }
  .logo-left-sec .bgimg{
    position: absolute;
    width:100%;
    height: 100%;
    z-index: -1;
    bottom: 0;
    left:0;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
  }
  .logo-left-sec .bgimg img{
    margin-bottom: -100px;
  }
  div[dir='rtl'] .logo-left-sec .bgimg{
    right: 0;
  }
  .logo-left-sec .logo {
    margin-left: 150px;
    width: 45%;
    margin-top: 15px;
  }
  div[dir='rtl'] .logo-left-sec .logo {
    margin-right: 150px;
    margin-left: 0;
  }
  .logo-left-sec .quote {
    color: #812d03;
    max-width: 500px;
    text-align: center;
  }
  .stars {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: url('/static/images/background-stars.png');
    z-index: 1;
  }
  ul {
    list-style-type: circle;
    color: #812d03;
    opacity: 0.8;
    max-width: 450px;
    margin-left: 100px;
    margin-top: 30px;
  }
  ul li {
    margin-bottom: 16px;
  }
  @media only screen and (min-width: 2000px) {
      .input-section img {
        width:100px;
      }
      .input-section input {
        height: 150px;
        border-bottom-width: 5px;
        font-size: 80px;
        text-indent: 130px;
      }
      .logo-left-sec .logo {
        margin-top: 10%;
        margin-left: 15%;
      }
      div[dir='rtl'] .logo-left-sec .logo {
        margin-left: initial;
        margin-right: 15%;
      }
      .logo-left-sec .bgimg img {
        margin-bottom: 0;
        width: 60%;
      }
      ul {
        margin-left: 10%;
        margin-top: 10%;
        font-size: 80px;
        width: 70%;
        max-width: inherit;
        line-height: 80px;
      }
      div[dir='rtl'] ul {
        margin-left: initial;
        margin-right: 10%;
      }
      ul li {
        margin-bottom: 50px;
      }
      form {
        width: 60% !important;
        height: 100% !important;
        min-height: 400px !important;
        max-height: inherit !important;
      }
      .mosque-login-details > div.login {
        width: 60% !important;
        height: 40vh;
        min-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15%;
      }
      .mosque-login-details {
        padding: 0;
      }
      .error-msg {
        font-size: 90px !important;
      }
    }

 /* @media screen and (min-width: 1280px) and (min-height: 1024px) { */
 @media screen and (min-width: 1200px) and (min-height: 904px) {
    .logo-left-sec .bgimg img {
      margin-bottom: 0px;
    }
    .mosque-login-details .login {
      width: 65% !important;
    }
    .login .form-class {
      justify-content: flex-start;
      align-items: flex-start;
    }
    form {
      max-height: 500px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue